import React from 'react'
import SliderList from './SliderList';

function Slider() {
    
    return (
        <div
          className="relative overflow-hidden h-48 sm:h-56 md:h-64 lg:h-72 bg-gray-100"
          // style={{ background: 'white '}}
        >
          <SliderList />
        </div>
      );
    };

    const injectStyles = () => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = `
        @keyframes slide-left-to-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
    
        .slider-list {
          animation: slide-left-to-right 15s linear infinite;
        }
      `;
      document.head.appendChild(styleSheet);
    };
    
    injectStyles();
    

export default Slider